import type { Instance, MethodStatus, DocumentReference, URLReference, Responsible, StandardModuleAsset } from '@/models/api-generated'
import type { ModuleType } from '@/models/module-enums-generated'

export type ModuleForm = {
	id?: number
	name: string
	description: string
	type: ModuleType
	version: string
	instance: Instance
	responsible?: Responsible
	isCustom: boolean
	active: boolean
	isApplicable: boolean
	assetAssociations: StandardModuleAsset[]
	urlReferences: URLReference[]
	documentReferences: DocumentReference[]
}

export type MethodForm = {
	id?: number
	name: string
	description: string
	type: string
	securityNeed: string
	confidentiality: boolean
	integrity: boolean
	availability: boolean
	rules: RuleForm[]
	isExpanded?: boolean
	status: MethodStatus
	applicable: boolean
}

export type RuleForm = {
	id?: number
	value: string
	subrules?: RuleForm[]
}

export enum Tabs {
	Module = 'module',
	Measures = 'measures',
}
